import React from 'react';
import { usePromiseTracker } from 'react-promise-tracker';

const Spinner: React.FunctionComponent<any> = () => {
    const { promiseInProgress } = usePromiseTracker();
    return (
        <div id="loading" className={promiseInProgress ? 'loading' : 'loading spinner-disable'}>
            <div className="peeek-loading">
                <ul>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
            </div>
        </div>
    );
};

export default Spinner;
